import { render, staticRenderFns } from "./MinFirstOrder.vue?vue&type=template&id=668eae91&"
import script from "./MinFirstOrder.vue?vue&type=script&lang=js&"
export * from "./MinFirstOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports